/// <amd-module name="Test/Timeline/Components/TestTimelineInBuildView" />
import * as BuildContracts from 'Build/Client/Contracts/Build';
import {
    DetailsSection,
    DetailsSectionContent,
    DetailsSectionHeader,
    DetailsSectionSecondaryHeader,
} from 'Build/Shared/Components/DetailsSection';
import {
    IContributedTimelineSnapshotProps,
    ITimelineSnapshotProps,
    SnapshotCallBack,
} from 'Build/Shared/Components/Timeline';
import { IStatusIconProps } from 'Build/Shared/Components/Timeline/Timeline.types';
import * as React from 'react';
import { ITestAnalyticsLinkData } from 'Test/Analytics/Common/Types';
import * as Common from 'Test/common-util/Common';
import * as TcmPerfScenarios from 'Test/common-util/TCMPerfScenarios';
import * as TelemetryConstants from 'Test/common-util/TelemetryConstants';
import { PassRateSourceService } from 'Test/PassRateChartView/Services/PassRateSourceService';
import { TestResultsReportActionsCreator } from 'Test/TestSummary/Actions/TestResultsReportActionsCreator';
import { TestResultsReportActionsHub } from 'Test/TestSummary/Actions/TestResultsReportActionsHub';
import { CompletedSummaryView } from 'Test/TestSummary/Components/CompletedSummaryView';
import { InProgressSummaryView } from 'Test/TestSummary/Components/InProgressSummaryView';
import { SummaryViewStore } from 'Test/TestSummary/Store/SummaryViewStore';
import * as Resources from 'Test/Timeline/Resources';
import { getTFSPageData } from 'Tfs/Platform/Page';
import * as Utils_String from 'VSS/Core/Util/String';
import { FPSLinkComponent } from 'VSS/Platform/Components/FPSLink';
import { IVssContributionService } from 'VSS/Platform/Contribution';
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { Components, VssComponent } from 'VSS/Platform/Layout';
import { routeUrl } from 'VSS/Platform/Location';
import { IVssPerformanceService } from 'VSS/Platform/Performance';
import { Tooltip } from 'VSSUI/TooltipEx';
import { VssIconType } from 'VSSUI/VssIcon';

export interface ITimelineSnapshotComponentState {
	testAnalyticsLinkData: ITestAnalyticsLinkData;
	artifactData: Common.IViewContextData;
}

export class TestTimelineSnapshotComponent extends VssComponent<IContributedTimelineSnapshotProps, ITimelineSnapshotComponentState> {

	constructor(props: IContributedTimelineSnapshotProps) {
		super(props);
		this.state = { testAnalyticsLinkData: {} as ITestAnalyticsLinkData } as ITimelineSnapshotComponentState;
	}

	public componentWillMount() {
		this._testReportActionsHub = new TestResultsReportActionsHub();
		this._performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
		this._performanceService.startScenario(TcmPerfScenarios.TestResultsInBuildTimeLine_SummaryDetails, false);
	}

	public componentWillUnmount() {
		if (this._onStoreStateChanged) {
			this._summaryViewStore.removeChangedListener(this._onStoreStateChanged);
		}
	}

	public componentDidUpdate(){
		if (!this._navMarked && this._currentState && (this._currentState.totalTestsCount > 0 || this._currentState.abortedTestsCount > 0)){
			this._performanceService.endScenario("Build", TcmPerfScenarios.TestResultsInBuildTimeLine_SummaryDetails, false);
            this._navMarked = true;
		}
	}

	public componentDidMount() {
		this._getTestAnalyticsLinkData().then((testAnalyticsLinkdData: ITestAnalyticsLinkData) => {
			this.setState({ testAnalyticsLinkData: testAnalyticsLinkdData });
			this._updateCallback();
		});
	}

	public render() {
		return <SnapshotSampleHolder
			className="test-timeline-view"
			snapshotKey={this.props.snapshotKey}
			iconProps={
				{
					name: "TestBeaker",
					type: VssIconType.fabric
				}
			}
			statusIconProps={this._getStatusProps()}
			initializeSnapshot={this._initializeSnapshot}
			ref={this.props.snapshotRef}>
			<div className="test-results-summary-view">
				<DetailsSection
					sectionKey="build-timeline"
					isExpandedByDefault={false}>
					<DetailsSectionHeader
						renderAsHeading={true}>
						<span>{this._renderTheHeader()}</span>
					</DetailsSectionHeader>
					<DetailsSectionSecondaryHeader>
						<span>{this._renderTheSubHeader()}</span>
					</DetailsSectionSecondaryHeader>
					<DetailsSectionContent>
						<div className="test-summary-view">
							{
								this.state.artifactData && this.state.artifactData.status === Common.ViewContextStatus.InProgress ?
									<InProgressSummaryView store={this._summaryViewStore} artifactData={this.state.artifactData} telemetryPropertiesForInProductLink={this._getTelemetryPropertiesForInProductLink()} isBuildTimeline={true}></InProgressSummaryView> :
									<CompletedSummaryView store={this._summaryViewStore} artifactData={this.state.artifactData} telemetryPropertiesForInProductLink={this._getTelemetryPropertiesForInProductLink()} isBuildTimeline={true}></CompletedSummaryView>
							}
						</div>
					</DetailsSectionContent>
				</DetailsSection>
			</div>
		</SnapshotSampleHolder>;
	}

	private _getTelemetryPropertiesForInProductLink(): { [propertyName: string]: any } {
		let telemetryProperties: { [propertyName: string]: any } = {
			[TelemetryConstants.workflow]: this.state.artifactData ? Common.ViewContext[this.state.artifactData.viewContext].toString() : "",
			[TelemetryConstants.id]: this.state.artifactData ? this.state.artifactData.data.mainData.id.toString() : ""
		};
		return telemetryProperties;
	}

	private _getStatusProps = (): IStatusIconProps | undefined => {
		let statusIcon;

		if (this._currentState) {
			if (this._currentState.isInProgress && this._currentState.totalTestsCount > 0) {
				return {
					iconName: "MSNVideosSolid",
					className: "status-large-icon inprogress-status-color"
				};
			}
			if (this._currentState.failedTestsCount > 0 || this._currentState.abortedTestsCount > 0) {
				return {
					iconName: "StatusErrorFull",
					className: "status-large-icon failure-status-color"
				};
			}
			statusIcon = {
				iconName: "CompletedSolid",
				className: "status-large-icon suceeded-status-color"
			};

		}

		return statusIcon;
	}

	private _initializeSnapshot = (build: BuildContracts.Build, callback: (marker: Date) => void, updateCallback: () => void) => {
		this._currentBuild = build;
		this.callbackDelegateOnTestResultsPresent = callback;
		this._updateCallback = updateCallback;
		let artifactData = this._getArtifactData(build);
		this.setState({
			artifactData: artifactData
		});
		// check if store is present, if it is then remove the listener of the first to avoid multiple listeneres
		if (this._summaryViewStore) {
			this._summaryViewStore.removeChangedListener(this._onStoreStateChanged);
		}
		this._summaryViewStore = new SummaryViewStore(this._storeChangeEvent, this.context, this._testReportActionsHub, artifactData);
		this._summaryActionCreator = new TestResultsReportActionsCreator(this._testReportActionsHub, this.context, artifactData);
		this._summaryViewStore.addChangedListener(this._onStoreStateChanged);
		this._summaryActionCreator.initialize(this._getArtifactData(build));
	}

	private _renderTheHeader = (): JSX.Element => {
		if (this._currentState && (this._currentState.totalTestsCount > 0 || this._currentState.abortedTestsCount > 0)) {
			return this._getHeaderElement();
		}

		return (<div />);
	}

	private _renderTheSubHeader = (): JSX.Element => {
		if (this._currentState && (this._currentState.totalTestsCount > 0 || this._currentState.abortedTestsCount > 0)) {
			let subHeaderElement = this._currentState.isInProgress ? this._getInProgressSubHeader() : this._getCompletedSubHeader();
			return <div className="timeline-sub-header"> {subHeaderElement} </div>;
		}

		return (<div />);
	}

	private _getInProgressSubHeader(): JSX.Element {
		return (<div className="inprogress-sub-header">
			{
				<span className="timeline-passed-header"> {this._currentState.totalTestsCount}<span> &nbsp;</span>{Resources.TotalTestsSubHeader}  </span>
			}
			{
				this._currentState.failedTestsCount > 0 &&
				<span><span> &nbsp;/&nbsp;</span> <span className="timeline-failed-tests"> {this._currentState.failedTestsCount}<span>&nbsp;</span>{Resources.FailedTestsSubHeader} </span></span>
			}
			{
				this._currentState.abortedTestsCount > 0 &&
				<span><span> &nbsp;/&nbsp;</span> <span className="timeline-aborted-tests"> {this._currentState.abortedTestsCount}<span> &nbsp;</span>{Resources.AbortedTestsSubHeader} </span></span>
			}
			{
				this.state.testAnalyticsLinkData && this.state.testAnalyticsLinkData.testAnalyticsLinkMessage &&
				<FPSLinkComponent className="timeline-test-analytics-link"
					href={this.state.testAnalyticsLinkData.testAnalyticsLink}
					telemetrySource={TelemetryConstants.featureAnalyticsInProductLink_PassRate_SummarySection}
					telemetryProperties={this._getTelemetryProperties()}>
					{this.state.testAnalyticsLinkData.testAnalyticsLinkMessage}
				</FPSLinkComponent>
			}
		</div>);
	}

	private _getCompletedSubHeader(): JSX.Element {
		let newFailureString = Utils_String.format(Resources.NewFailureSubHeading, this._currentState.newFailures);

		return (<div className="completed-sub-header">
			{
				this._currentState.passedPercentage &&
				<span className="timeline-passed-header">{this._currentState.passedPercentage}<span>%&nbsp;</span>{Resources.PassedText}</span>
			}
			{
				this._currentState.failedTestsCount > 0 &&
				<span>
					<span>&nbsp;/&nbsp;</span>
					<span className="timeline-failed-tests">
						{
							<span>{this._currentState.failedTestsCount}<span>&nbsp;</span>{Resources.FailedTestsSubHeader} </span>
						}
						{
							this._currentState.newFailures > 0 &&
							<span>{newFailureString}</span>
						}
					</span>
				</span>
			}
			{
				this._currentState.abortedTestsCount > 0 &&
				<span><span> &nbsp;/&nbsp;</span> <span className="timeline-aborted-tests">{this._currentState.abortedTestsCount}<span> &nbsp;</span>{Resources.AbortedTestsSubHeader} </span></span>
			}
			{this.state.testAnalyticsLinkData && this.state.testAnalyticsLinkData.testAnalyticsLinkMessage &&
				<FPSLinkComponent className="timeline-test-analytics-link"
					href={this.state.testAnalyticsLinkData.testAnalyticsLink}
					telemetrySource={TelemetryConstants.featureAnalyticsInProductLink_PassRate_SummarySection}
					telemetryProperties={this._getTelemetryProperties()}>
					{this.state.testAnalyticsLinkData.testAnalyticsLinkMessage}
				</FPSLinkComponent>
			}
		</div>);
	}

	private _getHeaderElement() {
		if (this._currentState.isInProgress) {
			return this._getBuildTestTabLink(Resources.TestsInProgressHeader);
		}

		if (this._currentState.abortedTestsCount > 0) {
			return this._getBuildTestTabLink(Resources.AbortedRunsTimelineHeader);
		}
		if (this._currentState.failedTestsCount > 0) {
			return this._getBuildTestTabLink(Resources.FailedTimelineHeader);
		}
		return this._getBuildTestTabLink(Resources.SucceededTimelineHeader);
	}

	private _onStoreStateChanged = () => {
		let currentState = this._summaryViewStore.getState();

		if ((currentState.isInProgressView && currentState.aggregatedTestsCount && currentState.aggregatedTestsCount.totalTests > 0) ||
			(currentState.totalTestsChartProps && currentState.totalTestsChartProps.aggregatedtotalTests > 0) ||
			(currentState.aggregatedRunsCount && currentState.aggregatedRunsCount.abortedRuns)) {
			this._setCurrentState();

			this.callbackDelegateOnTestResultsPresent(this._currentBuild.startTime || this._currentBuild.queueTime);
			this._updateCallback();
		} else {
			this._navMarked = true;
		}
	}

	private _setCurrentState = () => {
		let summaryViewCurrentState = this._summaryViewStore.getState();
		let isInProgressView = summaryViewCurrentState.isInProgressView;

		let totalTestsCount = isInProgressView ?
			summaryViewCurrentState.aggregatedTestsCount ? summaryViewCurrentState.aggregatedTestsCount.totalTests : 0 :
			summaryViewCurrentState.totalTestsChartProps ? summaryViewCurrentState.totalTestsChartProps.aggregatedtotalTests : 0;
		let failedTestsCount = isInProgressView ?
			summaryViewCurrentState.aggregatedTestsCount ? summaryViewCurrentState.aggregatedTestsCount.failedTests : 0 :
			summaryViewCurrentState.testFailuresChartProps ? summaryViewCurrentState.testFailuresChartProps.totalFailures : 0;
		let newFailures = summaryViewCurrentState.testFailuresChartProps ? summaryViewCurrentState.testFailuresChartProps.newFailures : 0;
		let abortedRunsCount = isInProgressView ?
			summaryViewCurrentState.aggregatedTestsCount ? summaryViewCurrentState.aggregatedTestsCount.abortedTests : 0 :
			summaryViewCurrentState.aggregatedRunsCount ? summaryViewCurrentState.aggregatedRunsCount.abortedRuns : 0;
		let passPercentage = summaryViewCurrentState.passPercentageNumberChartProps ? summaryViewCurrentState.passPercentageNumberChartProps.value : null;

		this._currentState = {
			isInProgress: isInProgressView,
			failedTestsCount: failedTestsCount,
			totalTestsCount: totalTestsCount,
			abortedTestsCount: abortedRunsCount,
			passedPercentage: passPercentage,
			newFailures: newFailures
		}
	}

	private _getBuildTestTabLink(headerLabel: string): JSX.Element {
		let builsSummaryTestTabUrl = this._getTheTestTabUrl();

		let isInProgressView = this._currentState.isInProgress;
		let hasFailedOrAbortedTests = this._currentState.failedTestsCount > 0 && this._currentState.abortedTestsCount > 0;
		let telemetryProperties: { [propertyName: string]: any } = {
			[TelemetryConstants.inProgress]: isInProgressView,
			[TelemetryConstants.failedTestsExists]: hasFailedOrAbortedTests
		};

		return <div className="timeline-header ci-hover-behavior">
			<Tooltip text={headerLabel}>
				<span>
					<FPSLinkComponent href={builsSummaryTestTabUrl}
						className={"test-results-page"}
						telemetrySource={TelemetryConstants.featureTimelineInBuild}
						telemetryProperties={telemetryProperties}>
						{headerLabel}
					</FPSLinkComponent>
				</span>
			</Tooltip>
		</div>;
	}

	private _getTheTestTabUrl(): string {
		if (!this._currentBuild) {
			return "";
		}
		const newBuildHubRoute: string = "ms.vss-build-web.ci-results-hub-route";
		const testExtensionViewId = this._getTestExtensionViewId();
		let tfsProjectData = getTFSPageData(this.context.pageContext);

		const routeValues: { [key: string]: string } = {};
		routeValues["buildId"] = this._currentBuild.id.toString();
		routeValues["view"] = testExtensionViewId;
		routeValues["project"] = tfsProjectData && tfsProjectData.project ? tfsProjectData.project.name : "";

		return routeUrl(this.context.pageContext, newBuildHubRoute, routeValues);
	}

	private _getTestExtensionViewId() {
		if (isFeatureFlagEnabled(this.context.pageContext, Common.FeatureFlagConstants.TestTabInNewWebPlatform, true)) {
			return "ms.vss-test-web.build-test-results-tab";
		} else {
			return "ms.vss-test-web.test-result-details"
		}
	}

	private _getArtifactData(build: BuildContracts.Build): Common.IViewContextData {
		const data: Common.IData = {
			mainData: build
		};
		const status: Common.ViewContextStatus = this._getBuildStatus(build);
		const artifactData: Common.IViewContextData = {
			viewContext: Common.ViewContext.Build,
			data: data,
			status: status
		};

		return artifactData;
	}

	private _getBuildStatus(build: BuildContracts.Build): Common.ViewContextStatus {
		if (build.status === BuildContracts.BuildStatus.InProgress) {
			return Common.ViewContextStatus.InProgress;
		} else if (build.status === BuildContracts.BuildStatus.Completed) {
			return Common.ViewContextStatus.Completed;
		} else {
			return Common.ViewContextStatus.Others;
		}
	}

	private async _getTestAnalyticsLinkData(): Promise<ITestAnalyticsLinkData> {
		let contributionService: IVssContributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
		await contributionService.getContributionAsync("ms.vss-test-analytics-web.pass-rate-chart-view");

		let passRateSource = this.context.pageContext.getService<PassRateSourceService>("PassRateSourceService");
		if (passRateSource) {
			passRateSource.initialize("PassRateSourceService", this.context.pageContext);
		}

		return passRateSource.getTestAnalyticsLinkData(this._currentBuild.definition.id);
	}

	private _getTelemetryProperties() {
		let telemetryProperties: { [propertyName: string]: any } = {
			[TelemetryConstants.workflow]: "Build",
			[TelemetryConstants.id]: this._currentBuild.id.toString()
		};
		return telemetryProperties;
	}

	private _currentBuild: BuildContracts.Build;
	private _testReportActionsHub: TestResultsReportActionsHub;
	private _summaryViewStore: SummaryViewStore;
	private _summaryActionCreator: TestResultsReportActionsCreator;
	private callbackDelegateOnTestResultsPresent: SnapshotCallBack;
	private _updateCallback: () => void;
	private _performanceService: IVssPerformanceService;
	private _storeChangeEvent: string = "summaryChangeEvent";
	private _currentState: ITimelineSnapshotState;
	private _navMarked: boolean = false;
}

// By doing this, we can avoid dependency on the Timeline component code it'self
// Otherwise, if it's already pulled in, then we could use TimelineSnapshot component
export class SnapshotSampleHolder extends React.Component<ITimelineSnapshotProps<BuildContracts.Build>, {}> {
	public render() {
		return <div>Note! This is just a holder, this text would never show up!</div>;
	}
}

export interface ITimelineSnapshotState {
	isInProgress: boolean | null;
	failedTestsCount: number;
	passedPercentage: string;
	totalTestsCount: number;
	abortedTestsCount: number;
	newFailures: number;
}

interface ISnapshotSampleProps {
}

Components.add("testTimelineComponent", TestTimelineSnapshotComponent);
